<div id="id-list" sxBackground="light" class="rounded-lg">

  @if (isLoading) {
  <div class="flex flex-row items-center p-2 gap-4">

    <ion-skeleton-text [animated]="true" sxWidth="70px" sxHeight="70px" sxRadius="medium"></ion-skeleton-text>

    <div sxWidth="fill" sxGap="5px" sxCol sxDistribution="center">
      <ion-skeleton-text [animated]="true" sxWidth="130px" sxHeight="16px" sxRadius="small"></ion-skeleton-text>
      <ion-skeleton-text [animated]="true" sxWidth="110px" sxHeight="12px" sxRadius="small"></ion-skeleton-text>
    </div>

  </div>
  }


  @if (selectedDocumentAccess && !isLoading) {
  <div class="flex flex-row items-center p-2 gap-4">
    <div class="shrink-0" sxWidth="70px" sxHeight="70px" sxCenterize="col" sxRadius="medium" sxBorderColor="one"
      sxBorderWidth="1px">
      @let scannedImages = selectedDocumentAccess?.documentData?.scannedImages;
      @if (scannedImages && scannedImages[0]?.imageUrl) {
      <img sxMatchParent class="cover-fit" [src]="ImageUtil.getImageSource(scannedImages?.[0]?.imageUrl)">
      }@else {

      <img sxWidth="75%" sxHeight="75%" class="contain-fit"
        [src]="ImageUtil.getImageSource(selectedDocumentAccess?.document?.sid?.logoUrl)">
      }
    </div>

    <div sxWidth="fill" sxGap="5px" sxCol sxDistribution="center" (click)="viewId()">
      @if (selectedDocumentAccess) {
      <div sxCol sxGap="5px">
        <p class="m-0 text-sm uppercase max-w-[160px] truncate">{{selectedDocumentAccess?.document?.documentNumberMasked
          ||
          'xx xx xxxx'}}</p>
        <p sxMargin="0" sxColor="two" sxTextSize="small">Saved on {{selectedDocumentAccess?.createTime | date}}</p>
      </div>
      }

    </div>

    @if (field?.data?.sid?.variants == 0) {
    <div sxRow sxAlign="center" sxPadding="medium">
      <div sxCircle="40px" sxCenterize="row" sxBorderWidth="1px" sxBorderColor="one"
        (click)="openViewDocumentOptionsPage()">
        <ion-icon name="pencil"></ion-icon>
      </div>
    </div>
    }
  </div>
  }


  @if (!selectedDocumentAccess && !isLoading) {
  <div>
    <super-button (click)="createId()" type="outline" borderColor="transparent">
      Upload
    </super-button>
  </div>
  }


</div>
@if (field.errorMessage) {
<p class="error-message">{{field.errorMessage}}</p>
}